import React from 'react';
import { MetaHead } from '../components/MetaHead';
import { WhoWeAre } from './WhoWeAre';

export function StaffPage() {
  return <WhoWeAre />;
}
